import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';

import { AdvancedTable, Helpers, TableSupport, FiltersUtils } from 'dsilo-ui-components';

import { Paper, Button, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from 'clsx';

import { Loader } from "../../components/loader";
import ConfirmationHandler from '../../components/ConfirmDialog';
import { fetchPrivilegeSupport } from '../../utility/AbilityCheck'; // Import ability function
import { setStructuredLocalStorage, getStructuredLocalStorage } from '../../utility/utils';

import { getOrgDetails } from "../../store/actions/org";
import { deleteMember, getMembersList, getAllMembersList, getModelDataDropDown, updateProfile, clearReduxDataOfCurrentComponent, downloadUserData } from '../../store/actions';

const sharedJSON = {
    "order": "asc",
    "orderBy": null,
    "selected": [],
    "tableData": [],
    "filterTableData": [],
    // "page": 0,
    "count": 10,
    // "rowsPerPage": 10,
    "searchText": "",
    "filterList": [],
    "filterData": []
}

const tableJson = [
    {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: 'Document Type',
        sort: true,
    },
    {
        id: 'keyValueFields',
        numeric: false,
        disablePadding: false,
        label: 'Key Data Fields',
        sort: true,
    },

];

const useStyles = makeStyles((theme) => {
    const isNewV1Theme = theme?.isNewV1Theme
    return {
    root: {
        width: "100%"
    },
    paper: {
        width: "100%",
        marginBottom: theme.spacing(2)
    },
    headerClass: {
        backgroundColor: "#f6f9fc",
        textTransform: 'capitalize',
    },
    confirmationDialoge: {
        "& .MuiDialog-paperWidthSm": {
            height: "250px",
            width: "600px"
        }
    },
    para: {
        fontSize: "28px !important",
        fontWeight: 600,
        color: "#000"
    },
    table: {
        '& td': {
            padding: '4px !important',
            textAlign: 'center',
        },
    },
    filterButton: isNewV1Theme ? {
        backgroundColor: '#fff',
        color: '#3F51B5',
        border: '1px solid #3F51B5',
        textTransform: 'capitalize', maxHeight: 40,
        '&:hover': {
            background:'#fff',
            color: '#3F51B5',
            opacity: 0.9
        },
    } : {},
   		filterButton1: isNewV1Theme ? {
        backgroundColor: '#3F51B5',
        color: '#fff',
        textTransform: 'capitalize', maxHeight: 40,
        padding: '8px 16px',
        '&:hover': {
            background:'#3F51B5',
            color: '#fff',
            opacity: 0.9
        },
    } : {},
    footer: isNewV1Theme ? {
        display: "flex",
        justifyContent: "end"
    } : {},
    pageTitle: isNewV1Theme ? {
        padding: "15px 0 0 15px"
    } : {}
}
})

const UserManagement = (props) => {
    const classes = useStyles()

    const { data, formData } = props;
    const { document } = formData
    const pageUrl = props.page?.url
    const { _id: userId = localStorage.getItem('userId') } = props.user
    const { chartData, chartUniqueId } = data
    const isNewV1Theme = document?.appConfig?.theme?.type === "v1.1";

    const [membersList, setMembersList] = useState([])
    const [state, setState] = useState({
        ...sharedJSON,
    });
    const [searchedText, setSearchedText] = useState('');

    const [deleteConfirmState, setDeleteConfirm] = useState({
        isOpen: false,
        deleteMessage: "Are you sure you want to delete ?",
        data: null
    })


    const [page, setPage] = useState(0)
    const [conditions, setConditions] = useState([])
    const [rowsPerPage, setRowsPerPage] = useState(chartData?.pagination?.rowsPerPage || 10)
    const [isHighlighted, setHighLighted] = useState({});
    const [previlageData, setPrevilageData] = useState("")
    const [localStorageObject, setLocalStorageObject] = useState({})
    const [highLighterIdForSelectedLineItem, setHighLighterIdForSelectedLineItem] = useState('');

    const [filterConditions, setFilterConditions] = useState([]) // filter array to be sent in api call
    const [selectedFilterValues, setFilterValues] = useState([]) // actual filter object
    const [externalFilterData, setExternalFilterData] = useState([]) // actual filter object
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [externalFilterValues, setExternalFilterValues] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);

    // Generate abilities based on privileges
    const [ability, setAbility] = useState(null);

    useEffect(() => {
        setState({ ...TableSupport.updateTableData(state) });
    }, [state.searchText, state.filterList]);

    useEffect(() => {
        if (membersList) {
            const rows = tableJson;
            // const rows = listViewTableJson;
            let keysArr = ['_id'];
            // setState({ ...TableSupport.setDatafromApi2(membersList, keysArr, state, rows) });
            setState(
                {
                    ...TableSupport.setDatafromApi2(
                        getData(membersList),
                        keysArr,
                        state,
                        getColumns()
                    ),
                    count: document[chartUniqueId + '_all_members']?.total
                }
            );
            isHighlightedTile()
        }
    }, [membersList]);

    useEffect(() => {
        let localStoreJson = localStorage.getItem('userSession');
        let currentUserSes, _currSessPage = 0, _currSessRPP = rowsPerPage, updatedConditions = [];
        if (localStoreJson) {
            let currentSession = JSON.parse(window.atob(localStoreJson));
            if (Object.keys(currentSession).length > 0) {
                if (currentSession && currentSession[userId] && currentSession[userId][pageUrl]) {
                    currentUserSes = currentSession[userId][pageUrl];
                    if (currentUserSes?.page) {
                        _currSessPage = Number(currentUserSes?.page)
                        setPage(_currSessPage)
                    }
                    if (currentUserSes?.rowsPerPage) {
                        _currSessRPP = Number(currentUserSes?.rowsPerPage)
                        setRowsPerPage(_currSessRPP)
                    }
                }
            }
        }
        const localObj = getStructuredLocalStorage(userId, props.appId, pageUrl);
        if (localObj?.filters) {
            setFilterValues(localObj?.filters)
            updatedConditions = FiltersUtils.createConditions(localObj?.filters, chartData.externalFilter)
            setFilterConditions(updatedConditions)
            setPage(localObj?.page)
            setRowsPerPage(localObj?.rowsPerPage)  
        }
        fetchData(localObj?.page || _currSessPage, localObj?.rowsPerPage || _currSessRPP, '', updatedConditions)
        fetchAllMembersData()
    }, [])

    useEffect(() => {
        if (document?.[chartUniqueId + "_delete_member"]) {
            toast.success(document?.[chartUniqueId + "_delete_member"].message || 'Deleted successfully')
            props.clearReduxDataOfCurrentComponent({
                key: "document",
                subKey: [chartUniqueId + "_delete_member"]
            })
            fetchData()
            fetchAllMembersData()
        }
    }, [document?.[chartUniqueId + "_delete_member"]])

    const getAllValsAsString = (data) => {
        if (data && data.length) {
            let str = '';
            data.map((d) => str = str + d.name + ', ');
            str = str.slice(0, str.length - 2);
            return str;
        } else {
            return '';
        }
    }

    useEffect(() => {
        if (document?.[chartUniqueId + "_all_members"]?.data?.length >= 0) {
            let membersListData = document[chartUniqueId + "_all_members"]?.data?.map(k => ({
                firstName: k.firstName ? k.firstName : k.name?.split(" ")[0],
                lastName: k.lastName ? k.lastName : k.name?.split(" ")[1],
                roles: getAllValsAsString(k.roles && k.roles.length ? k.roles : []),
                groups: getAllValsAsString(k.groups && k.groups.length ? k.groups : []),
                supervisor: k.supervisor && k.supervisor.id ? k.supervisor.name : '',
                _id: k._id,
                email: k.email
            }))
            setMembersList(membersListData)
        }
    }, [document?.[chartUniqueId + "_all_members"]])

    // It is for external filters
    useEffect(() => {
        if (document && props.formData.document[chartUniqueId + "_members"]?.length) {
            let _externalFilterData = []
            const emails = [], firstNames = [], lastNames = []
            document[chartUniqueId + "_members"].forEach(k => {
                let firstName = k.firstName ? k.firstName : k.name?.split(" ")?.[0];
                let lastName = k.lastName ? k.lastName : k.name?.split(" ")?.[1];
                emails.push({
                    label: k.email, value: k.email, name: 'email'
                })
                firstNames.push({
                    label: firstName, value: firstName, name: 'firstName'
                })
                lastNames.push({
                    label: lastName, value: lastName, name: 'lastName'
                })
            })
            _externalFilterData = [...[emails], ...[firstNames], ...[lastNames]];
            // console.log("externalFilter === In main component", _externalFilterData);
            setExternalFilterData(_externalFilterData);
        }
    }, [document?.[chartUniqueId + "_members"]])

    useEffect(() => {
        if (localStorage.getItem('userSession')) {
            let userSession = JSON.parse(window.atob(localStorage.getItem('userSession')))
            if (Object.keys(userSession).length === 0) {
                if (Object.keys(localStorageObject).length > 0) {
                    localStorage.setItem('userSession', window.btoa(JSON.stringify({
                        [userId]: { [pageUrl]: { ...localStorageObject } }
                    })))
                }
            } else {
                for (let [key, value] of Object.entries(userSession)) {
                    if (key === userId) {
                        for (let [key1, value1] of Object.entries(value)) {
                            if (key1 === pageUrl) {
                                userSession[userId][pageUrl] = { ...value1, ...localStorageObject }
                                localStorage.setItem('userSession', window.btoa(JSON.stringify(userSession)))
                            } else {
                                if (Object.keys(localStorageObject).length > 0) {
                                    userSession[userId][pageUrl] = { ...localStorageObject }
                                    localStorage.setItem('userSession', window.btoa(JSON.stringify(userSession)))
                                }
                            }
                        }
                    }
                }
            }
        } else if (Object.keys(localStorageObject).length > 0) {
            localStorage.setItem('userSession', window.btoa(JSON.stringify({
                [userId]: { [pageUrl]: { ...localStorageObject } }
            })))
        }
    }, [localStorageObject])

    useEffect(() => {
        if (state.order && state.orderBy) {
            fetchData()
        }
    }, [state.order, state.orderBy])

    const isHighlightedTile = () => {
        let userSession = localStorage.getItem('userSession')
        if (userSession) {
            userSession = JSON.parse(window.atob(userSession))
            let currentUserSession = userSession && userSession[userId]
            let currentUserSessionPage = userSession && currentUserSession && currentUserSession[pageUrl]
            if (currentUserSessionPage?.selectedLineItem) {
                setHighLighterIdForSelectedLineItem(currentUserSessionPage?.selectedLineItem)
            }
        }
    }

    const fetchData = (_page = page, _rowsPerPage = rowsPerPage, _searchText = '', _conditions = []) => {
        props.getAllMembersList({
            appId: props.appId,
            dataUniqueId: chartUniqueId + '_all_members',
            payload: {
                page: _page,
                rowsPerPage: _rowsPerPage,
                ...(_searchText && { search: _searchText }),
                ...(state.order &&
                    state.orderBy && {
                    sort: state.order,
                    sortBy: state.orderBy,
                }),
                ...(_conditions && _conditions.length && {
                    conditions: _conditions
                })
            },
        });
    }

    const handleFilterClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleFilterClose = (type) => {
        switch (type) {
            case 'save':
                setAnchorEl(null);
                // onExternalFilterChange(externalFilterValues)
                // setFilterValues(externalFilterValues)
                break;
            case 'close':
                setAnchorEl(null);
                break;
            case 'clearAll':
                for (let vals in externalFilterValues) {
                    externalFilterValues[vals] = null;
                }
                onExternalFilterChange(externalFilterValues)
                setFilterValues(externalFilterValues)
                break;
        }
    };
    
    const fetchAllMembersData = () => {
        props.getMembersList({
            appId: props.appId,
            orgId: props?.user?.orgId,
            dataUniqueId: chartUniqueId + '_members',
        });
    }

    const getData = (dataSource, fetchType) => {
        const clonedDataSource = JSON.parse(JSON.stringify(dataSource))
        return clonedDataSource.map((item) => {
            const keys = Object.keys(item)
            keys.forEach((key) => {
                if (key && typeof item[key] !== "string") {
                    if (fetchType === "keysArray" && !selectedInnerSupportDataElement) {
                        if (chartData?.selectedInnerDataElement?.length) {
                            chartData?.selectedInnerDataElement?.map(side => {
                                if (side.value === key) {
                                    if (side.type === "namepicker") {
                                        if (item[key] instanceof Array) {
                                            item[key] = item[key].map(obj => obj.label).join(', ')
                                        } else {
                                            item[key] = item[key]
                                                ? (typeof item[key] === "object"
                                                    ? item[key][label]
                                                    : item[key])
                                                : ""
                                        }
                                    } else {
                                        item[key] = item[key] || item[key] === 0 ? JSON.stringify(item[key]) : ""
                                    }
                                }
                            })
                        } else {
                            item[key] = item[key] || item[key] === 0 ? JSON.stringify(item[key]) : ""
                        }
                    } else {
                        if (chartData?.selectedDataElement?.length) {
                            chartData?.selectedDataElement?.map(sde => {
                                if (sde.value === key) {
                                    if (sde.type === "namepicker") {
                                        if (item[key] instanceof Array) {
                                            item[key] = item[key].map(obj => obj.label).join(', ')
                                        } else {
                                            item[key] = item[key]
                                                ? (typeof item[key] === "object"
                                                    ? item[key][label]
                                                    : item[key])
                                                : ""
                                        }
                                    } else {
                                        item[key] = item[key] || item[key] === 0 ? JSON.stringify(item[key]) : ""
                                    }
                                }
                            })
                        } else {
                            item[key] = item[key] || item[key] === 0 ? JSON.stringify(item[key]) : ""
                        }
                    }
                    // item[key] = item[key] || item[key] === 0 ? JSON.stringify(item[key]) : ""
                }
            })
            return item
        })
    }

    const getColumns = () => {
        let COLUMNS = []
        if (membersList?.length > 0) {
            COLUMNS = Object.keys(
                membersList[0]
            ).map((i) => {
                return {
                    id: i,
                    name: i,
                    numeric: false,
                    disablePadding: false,
                    label: Helpers.camelCaseToSentenceCase(i),
                    sort: true,
                    checked: true
                }
            }).filter(i => i.id !== '_id')
        } else {
            COLUMNS = chartData?.selectedDataElement?.map((i) => {
                return {
                    id: i?.value,
                    name: i?.value,
                    numeric: false,
                    disablePadding: false,
                    label: i?.label,
                    sort: true,
                    checked: true
                }
            })
        }

        return COLUMNS
    }

    const handleChangePage = (event, page) => {
        fetchData(page, rowsPerPage, searchedText || '', filterConditions)
        setPage(page)
        setLocalStorageObject({ ...localStorageObject, page: page })
    };

    const onAddClick = () => {
        props.history.push({ pathname: `/${props.match.params.appid}/page/member/new` });
    }

    const handleChangeRowsPerPage = event => {
        fetchData(0, event.target.value, searchedText || '', filterConditions)
        setRowsPerPage(event.target.value)
        setPage(0)
        setLocalStorageObject({ ...localStorageObject, rowsPerPage: event.target.value, page: 0 })
    };

    const onRowClick = (rowData, rowMeta) => {
        console.log('onRowClick');
    };

    const searchHandler = (e) => {
        setSearchedText(e ? e.target.value : "")
    }

    const onSearchEnter = (e, onSearchButton = false) => {
        if (e === null) {
            setPage(0)
            fetchData(0, rowsPerPage, '', filterConditions)
            searchHandler(null)
        } else if (e?.keyCode === 13 || onSearchButton) {
            setPage(0)
            fetchData(0, rowsPerPage, searchedText, filterConditions)
        }
    }

    const handleInputChange = event => {
        let obj = state.filterTableData;
        let list = obj.columns;
        list.map((item, index) => {
            if (item.name === event.target.value) list[index].checked = event.target.checked;
        });
        obj.columns = [...list];
        setState({ ...state, filterTableData: obj });
        setState({ ...TableSupport.updateTableData(state) });
    };

    const resetFilters = event => {
        setState({ ...state, filterList: [] });
    };

    const handleDropdownChange = (event, index, column) => {
        const value = event.target.value === 'All' ? [] : [event.target.value];
        // filterUpdate(index, value, column, 'dropdown');
        let list = state.filterList;
        list[index] = event.target.value;
        setState({ ...state, filterList: [...list] });
        setState({ ...TableSupport.updateTableData(state) });
    };

    const handleRequestSort = (event, property) => {
        let obj = TableSupport.requestSort(event, property, state);
        setState({ ...state, ...obj });
    };

    const handleSelectAllClick = event => {
        setState({
            ...state,
            selected: TableSupport.handleTableSelectAllClick(event, state.filterTableData.datasets),
        });
    };

    const onClickAnyAction = (docId) => {
        const { _id: userId } = props.user
        if (localStorage.getItem('userSession')) {
            let userSession = JSON.parse(window.atob(localStorage.getItem('userSession')))
            for (let [key, value] of Object.entries(userSession)) {
                if (key === userId) { // userId matched
                    for (let [key1, value1] of Object.entries(value)) {
                        if (key1 === pageUrl) { // page matched
                            userSession[userId][pageUrl] = { ...value1, 'selectedLineItem': docId }
                            localStorage.setItem('userSession', window.btoa(JSON.stringify(userSession)))
                        } else {
                            if (Object.keys(userSession).length > 0) {
                                userSession[userId][pageUrl] = { ...value1, 'selectedLineItem': docId }
                                localStorage.setItem('userSession', window.btoa(JSON.stringify(userSession)))
                            }
                        }
                    }
                }
            }
        } else {
            localStorage.setItem('userSession', window.btoa(JSON.stringify({ [userId]: { [pageUrl]: { 'selectedLineItem': docId } } })))
        }
    }

    const tableCrudOperations = (item, type) => {
        if (type === 'edit') {
            onClickAnyAction(item._id)

            props.history.push({
                pathname: `/${props.match.params.appid}/page/${chartData.editPage}/${item._id}`,
            })
        }
        if (type === 'delete') {
            setDeleteConfirm({
                ...deleteConfirmState,
                isOpen: true,
                data: item._id
            })
        }

    };

    const onDeleteResponse = (isDelete) => {
        if (isDelete) {
            const payload = {
                appid: props.appId,
                dataUniqueId: chartUniqueId + "_delete_member",
                orgId: props.user.orgId,
                id: deleteConfirmState.data
            }
            props.deleteMember(payload)
        }
        setDeleteConfirm({ ...deleteConfirmState, isOpen: false, data: null })
    }

    const handleCheck = (event, id) => {
        const { selected } = state;
        let newSelected = TableSupport.handleSelectedRow(event, id, selected);
        setState({ ...state, selected: newSelected });
        props.checkedContractChanged(newSelected);
    };

    const onExternalFilterChange = (filterValues) => {
        console.log("onExternalFilterChange === filterValues", filterValues)
        let _page = 0, _rowsPerPage = rowsPerPage || chartData?.pagination?.rowsPerPage || 10;
        setPage(_page)
        setRowsPerPage(_rowsPerPage)

        let updatedConditions = FiltersUtils.createConditions(filterValues, chartData.externalFilter)
        setFilterConditions(updatedConditions)
        setFilterValues(filterValues)

        setStructuredLocalStorage(
            userId,
            props.appId,
            pageUrl,
            { 'filters': filterValues, 'page': page, 'rowsPerPage': _rowsPerPage }
        );

        fetchData(_page, _rowsPerPage, '', updatedConditions)
    }

    const downloadAllUsers = () => {
        setIsDownloading(true);
        const payload = {
            appId: props.appId,
            orgId: props.user.orgId,
            dataUniqueId: chartUniqueId + '_download_user_data',
            fields: ['firstName', 'lastName', 'email', 'roles', 'groups', 'supervisor'],
            ...(searchedText && { search: searchedText }),
            ...(filterConditions && filterConditions.length && { conditions: filterConditions })
        };
        props.downloadUserData(payload);
    }

    // Member Privileges code end here
    useEffect(() => {
        const { privilegeData, ability } = fetchPrivilegeSupport(props, chartData);
        setPrevilageData(privilegeData);
        setAbility(ability);
    }, [
        props.formData.document[`${props.match.params.appid}_memberprivileges`],
        props?.privilegesSupport,
        props.match.params.page,
        window.location.pathname,
        chartData?.selectedDataModel
    ]);
    // Member Privileges code end here

    // Handle download success/error
    useEffect(() => {
        const resKey = chartUniqueId + '_download_user_data';
        if (document?.[resKey] && document?.[resKey]?.data?.success) {
            setIsDownloading(false);
            toast.success('Users data downloaded successfully');
            props.clearReduxDataOfCurrentComponent({
                key: "document",
                subKey: [resKey]
            });
        }
        if (document?.[resKey] && !document?.[resKey]?.data?.success) {
            setIsDownloading(false);
            toast.error('Failed to download users data');
            props.clearReduxDataOfCurrentComponent({
                key: "document",
                subKey: [resKey]
            });
        }
    }, [document[chartUniqueId + '_download_user_data'], chartUniqueId]);

    return (
        <>
            <Paper className={classes.table} elevation={3}>
                <AdvancedTable
                    name={'UsersList'}
                    onRowClick={onRowClick}
                    {...props}
                    {...state}
                    chartData={chartData}
                    title={props.page?.title}
                    searchedText={searchedText}
                    searchHandler={searchHandler}
                    onSearchEnter={onSearchEnter}
                    isExport={false}
                    isViewCoulmns={false}
                    isSearch={chartData?.isSearch || false}
                    isLoading={props.formData[chartUniqueId + "_all_members_loading"]}
                    isFilter={false}
                    hasCheckbox={false}
                    actions={{ edit: true, view: false, delete: true, copy: false, download: false }}
                    
                    isTableHead={true}
                    isTableSubHeader={false}
                    associatedFormName={chartData.associatedFormName}
                    handleInputChange={handleInputChange}
                    onAddClick={onAddClick}
                    
                    handleDropdownChange={handleDropdownChange}
                    handleRequestSort={handleRequestSort}
                    handleSelectAllClick={handleSelectAllClick}
                    tableCrudOperations={tableCrudOperations}
                    handleCheck={handleCheck}

                    // Pagination
                    page={page}
                    paginationPage={page}
                    rowsPerPage={rowsPerPage}
                    isTablePagination={true}
                    pagination={chartData?.pagination}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}

                    // css
                    headerstyle={{
                        fontSize: "14px",
                        textAlign: "center",
                        color: "rgba(0, 0, 0, 0.87)",
                        backgroundColor: "#"
                    }}
                    subHeaderstyle={{
                        fontSize: "14px",
                        color: "rgba(0, 0, 0, 0.87)",
                        backgroundColor: "#FFF",
                        textAlign: "center"
                    }}
                    headerClass={classes.headerClass}
                    rowStyle={{
                        fontSize: "14px",
                        color: "rgba(0, 0, 0, 0.87)",
                        backgroundColor: "none",
                        lineHeight: 1.5,
                        textAlign: "center",
                        padding: 0,
                    }}
                    tableBodyCss={isNewV1Theme ? {} : { border: "1px solid lightGrey" }}

                    // External filters
                    resetFilters={resetFilters}
                    externalFilters={chartData?.externalFilter}
                    externalFilterData={externalFilterData}
                    externalFilterValues={selectedFilterValues}
                    onExternalFilterChange={onExternalFilterChange}

                    stripRows
                    loader={<Loader />}
                    isNestedTable={props.isNestedTable}
                    onExapandIconClick={props.onExapandIconClick}
                    nestedTableData={props.nestedTableData}
                    // isHighlighted={isHighlighted}
                    // userIdForHightList={userId}
                    highLighterIdForSelectedLineItem={highLighterIdForSelectedLineItem}
                    previlageData={previlageData}
                    ability={ability}
                    isNewV1Theme={isNewV1Theme}
                    anchorEl={anchorEl}
                    setAnchorEl={setAnchorEl}
                    handleFilterClose={handleFilterClose}
                    handleFilterClick={handleFilterClick}               
                    setExternalFilterValues={setExternalFilterValues}
                    classes={classes}
                    isDownloading={isDownloading}
                    downloadAllUsers={downloadAllUsers}
                />
            </Paper>
            <ConfirmationHandler
                open={deleteConfirmState.isOpen}
                handleClose={onDeleteResponse}
                alertMessageText={deleteConfirmState.deleteMessage}
                classes={classes}
                confirm
            />
        </>
    )
}

const mapDispatchToProps = {
    updateProfile,
    getOrgDetails,
    getMembersList,
    getAllMembersList,
    getModelDataDropDown,
    deleteMember,
    clearReduxDataOfCurrentComponent,
    downloadUserData
}

const mapStateToProps = state => {
    return {
        user: state.user,
        org: state.org,
        member: state.appConfig.members,
        formData: state.form,
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserManagement));